import { useCallback } from 'react'
import { updateCompany } from '@/features/domain/company'
import { useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'
import { useTexts } from '../hooks/useTexts'
import { resetEditingState } from '@/atoms'
import { useController } from './useController'
import { FormValues } from '../../../types'

export function useOnSubmit() {
  const toast = useNotification()
  const texts = useTexts()

  const dispatch = useAppDispatch()

  const {
    close,
    data: { company },
  } = useController()

  return useCallback(
    async (formValues: FormValues) => {
      try {
        const result = await dispatch(updateCompany({ ...company, name: formValues.name }))

        if (updateCompany.rejected.match(result)) {
          throw new Error(result.payload?.message ?? 'Internal error')
        }

        toast.success(texts.toast.success)

        resetEditingState()
        close?.()
      } catch (e) {
        toast.error(e.message)
      }
    },
    [toast, close, dispatch, company, texts],
  )
}
